import { aroFetch, aroFetchForm } from "../aroApi";
import { ImportCheckResult, ImportResponse, FileRecord, FileListResponse } from "../../types/aro";

/** Dry run — writes nothing. Form fields: file, issuer_company_name. */
export async function checkImport(formData: FormData): Promise<ImportCheckResult> {
  return aroFetchForm<ImportCheckResult>("/api/import/check", formData);
}

/** Form fields: file, uploaded_by, issuer_company_name, certificate_mapping (JSON), event_mapping (JSON). */
export async function importCsv(formData: FormData): Promise<ImportResponse> {
  return aroFetchForm<ImportResponse>("/api/import", formData);
}

export async function fetchFile(fileId: string): Promise<FileRecord> {
  return aroFetch<FileRecord>(`/api/files/${fileId}`);
}

export async function fetchFiles(params: {
  uploaded_by?: string;
  status?:      string;
  limit?:       number;
  offset?:      number;
} = {}): Promise<FileListResponse> {
  const q = new URLSearchParams();
  if (params.uploaded_by) q.set("uploaded_by", params.uploaded_by);
  if (params.status)      q.set("status",      params.status);
  if (params.limit  != null) q.set("limit",  String(params.limit));
  if (params.offset != null) q.set("offset", String(params.offset));
  const qs = q.toString();
  return aroFetch<FileListResponse>(`/api/files${qs ? `?${qs}` : ""}`);
}
